import { useQuery } from '@tanstack/react-query';
import { getDetailWebhookRegistrationQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

const useGetDetailWebhookRegistration = (id) => {
  return useQuery({
    enabled: !!id,
    queryKey: queryKeys.getDetail(id),
    queryFn: () => getDetailWebhookRegistrationQuery(id),
  });
};

export default useGetDetailWebhookRegistration;
